import { Col, Layout, Progress, Row, Tag } from 'antd';
import { UserOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Domain } from '../../apis/mgmt/api';
import { ClickableProps, DataViewProps } from '../common/DataView';
import { Content, Footer } from 'antd/es/layout/layout';


export const DomainCard = function ( props:
    DataViewProps<Domain> & ClickableProps<Domain>
) {

    const data = props.data;
    const onClick = () => { 
        data && props.onClick && props.onClick(data); 
    }

    // css card classes success, waiting, warn, error, process
    const state = 'process';
    const infoByState = {
        success: { color: '#50B692', text: 'online' },
        waiting: { color: '#6FC8F2', text: 'reconecting' },
        warn: { color: '#F3C15C', text: 'warning' },
        error: { color: '#b65057ff', text: 'error' },
        process: { color: '#6FC8F2', text: 'online' },
    };

    const owners = data?.permissions
    ?.filter(p => p.role?.level === 'OWNER')
    ?.map((p, index, array) => (
        <span key={p.id} title={`${p.user?.phone} ${p.user?.email}`}>
        {[p.user?.firstName,p.user?.lastName].filter(n=>n).join(' ')}{index < array.length - 1 && ', '}
        </span>
    ));

    return (data && (
        <Col key={data.id} xs={24} sm={24} md={12} lg={8} xl={8}>
        <Layout>
            <div className={"mig-card pointer mig-border-running " + state} onClick={onClick}>

                <Content>
                    <Row >
                        <Col>
                            <div className={'mig-card-content pointer'} >
                                <span className='mig-title-2'>{data.slug}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: "1em" }}>
                        <Col span={24}>
                        <small className='small'>{data.id}</small>
                        </Col>
                    </Row>
                </Content>
                
                <Footer>
                    <Row>
                        <Col span={18}>
                            {owners && <small><UserOutlined /> {owners}</small>}
                        </Col>
                        <Col span={6}>
                            <div style={{ textAlign: "end" }}>
                                <small><UserOutlined /> {data.permissions?.filter(p => p.role?.level === 'OWNER').length} </small>
                                <small><UsergroupAddOutlined /> {data.permissions?.length}</small>
                            </div>
                        </Col>
                    </Row>
                </Footer>

            </div>
        </Layout>
        </Col>
    )) || null;
}
